import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
export class ApiEpBillingProductFeatureSubscription {
}
ApiEpBillingProductFeatureSubscription.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/feature-subscription/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingProductFeatureSubscription.purchase = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/feature-subscription/${req.path.id}/purchase`,
    method: "POST",
});
ApiEpBillingProductFeatureSubscription.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/feature-subscription/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=feature_subscription.js.map